import React, { useMemo } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import isNull from 'lodash/isNull';
var loadingIcon = React.createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true });
export function useLoadingProps(list) {
    return useMemo(function () {
        return {
            delay: 50,
            indicator: loadingIcon,
            spinning: isNull(list),
            wrapperClassName: 'loading-wrapper',
        };
    }, [list]);
}
//# sourceMappingURL=hooks.js.map